'use client';
import * as React from "react";
import { useTeachingPopoverCarouselFooterButton_unstable } from "./useTeachingPopoverCarouselFooterButton.js";
import { renderTeachingPopoverCarouselFooterButton_unstable } from "./renderTeachingPopoverCarouselFooterButton.js";
import { useTeachingPopoverCarouselFooterButtonStyles_unstable } from "./useTeachingPopoverCarouselFooterButtonStyles.styles.js";
import { useCustomStyleHook_unstable } from "@fluentui/react-shared-contexts";
/**
 * TeachingPopoverCarouselFooterButton component
 *
 * TeachingPopoverCarouselFooterButton extends Button and injects additional styling and onClick functionality
 * to match the context provided by TeachingPopover & TeachingPopoverCarousel
 */ export const TeachingPopoverCarouselFooterButton = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useTeachingPopoverCarouselFooterButton_unstable(props, ref);
    useTeachingPopoverCarouselFooterButtonStyles_unstable(state);
    useCustomStyleHook_unstable('useTeachingPopoverCarouselFooterButtonStyles_unstable')(state);
    return renderTeachingPopoverCarouselFooterButton_unstable(state);
});
TeachingPopoverCarouselFooterButton.displayName = 'TeachingPopoverCarouselFooterButton';
